import { createSlice } from "@reduxjs/toolkit";
import { getChannelCuttingList } from "../../reduxApi/admin/ChannelCuttingReduxApi";

const ChannelCuttingSlice = createSlice({
  name: "ChannelCutting",
  initialState: {
    status: "idle",
    isFiltered: false,
    channelCutting: [],
  },

  reducers: {
    setFilteredStatus: (state, action) => {
      state.isFiltered = action.payload;
    },

    deleteChannelCuttingAction: (state, action) => {
      action.payload.forEach((id) => {
        const index = state.channelCutting.findIndex(
          (item) => item.ROWID === id
        );

        if (index !== -1) {
          state.channelCutting.splice(index, 1);
        }
      });
    },

updateChannelCuttingAction: (state, action) => {
    const { ROWID, payload } = action.payload;
  const index = state.channelCutting.findIndex(
    (item) => item.ROWID === action.payload.ROWID
  );

  if (index !== -1) {
    state.channelCutting[index] = {
   ...state.channelCutting[index],
      ...payload,  
    };
  }
},

    addChannelCuttingAction: (state, action) => {
      state.channelCutting.unshift(action.payload);
    },

    clearFilters: (state) => {
      state.isFiltered = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getChannelCuttingList.pending, (state) => {
        state.status = "pending";
      })

       .addCase(getChannelCuttingList.fulfilled, (state, action) => {
                      state.status = "fulfilled";
                      state.channelCutting = action.payload?.data || action.payload
                  })     

      .addCase(getChannelCuttingList.rejected, (state) => {
        state.status = "rejected";
      });
  },
});

export const {
  deleteChannelCuttingAction,
  updateChannelCuttingAction,
  addChannelCuttingAction,
  setFilteredStatus,
  clearFilters,
} = ChannelCuttingSlice.actions;

export default ChannelCuttingSlice.reducer;